import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

export const cancelUnitTaskQueue = async (model: IUnitTaskQueueModel): Promise<IUnitTaskQueueModel> =>
  axios.delete(`/management/UnitProgramTask/CancelTaskQueue?id=${model.id}`).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskQueueModel
}

export const useManagementCancelUnitTaskQueue = (notify?: boolean, onSuccess?: (data: IUnitTaskQueueModel) => void) =>
  useMutation({
    mutationKey: ['cancelUnitTaskQueue'],
    mutationFn: ({ model }: Props) => cancelUnitTaskQueue(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Cancelled queue item.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to cancel queue item. Can only cancel queue items that have the "status" of "pending" or "failed".')
      }
    },
    throwOnError: false
  })
